export default [{
	path: 'systemSetting',
	component: () => import('../../sys/system/setting'),
	meta: {
		title: '（系统设置）后台管理'
	}
}]
